/**
 * Copyright (C) 2023 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React, { useEffect, useState } from 'react';
import { TailDetailsPanelProps, PANEL_HEADER_HEIGHT_PX, TAIL_DETAILS_PANEL_WIDTH } from './TailDetailsPanel';
import isNil from 'lodash/isNil';
import { MyLocation, Block, ArrowBack } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { TailDetailsPanelHeaderDiv, panToTailOnMap } from './TailDetailsPanelHeader';
import FullTailViewSelectorContainer from '../../fleet/FullTailView/FullTerminalViewTerminalSelectorContainer';
import { BackButtonStyledWrapper } from '../FullTailView/FullTailViewHeaderContents';
import { useHistory } from 'react-router-dom';
import MenuItems from '../../common/layout/menu/MenuItems';

interface SpaceVehicleDetailsPanelFullSpaceVehicleHeaderProps extends TailDetailsPanelProps {}

const SpaceVehicleDetailsPanelFullSpaceVehicleHeader = ({
  selectedDatapathUuidFleetView,
  tailDetailsPanelTerminal,
  terminals,
  isRequestingTailDetailsPanelTerminal,
  setMapZoomLatLngFleetView,
}: SpaceVehicleDetailsPanelFullSpaceVehicleHeaderProps) => {
  const [initialPanMapLatLng, setInitialPanMapLatLng] = useState(false);
  const history = useHistory();

  // Pan map to Space Vehicle tail tag on mount and when user selects a different terminal on the dropdown
  useEffect(() => {
    if (
      !initialPanMapLatLng &&
      !isNil(tailDetailsPanelTerminal) &&
      !isNil(tailDetailsPanelTerminal.latitudeDeg) &&
      !isNil(tailDetailsPanelTerminal.longitudeDeg)
    ) {
      panToTailOnMap(tailDetailsPanelTerminal, terminals, selectedDatapathUuidFleetView, setMapZoomLatLngFleetView);
      setInitialPanMapLatLng(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tailDetailsPanelTerminal]);
  useEffect(() => {
    if (!isNil(selectedDatapathUuidFleetView)) {
      setInitialPanMapLatLng(false);
    }
  }, [selectedDatapathUuidFleetView]);

  return (
    <TailDetailsPanelHeaderDiv height={PANEL_HEADER_HEIGHT_PX} width={TAIL_DETAILS_PANEL_WIDTH}>
      <BackButtonStyledWrapper>
        <IconButton
          className="ftv__header__back--container"
          onClick={() => {
            history.push(`/${MenuItems.transportMonitoring}`);
          }}
        >
          <ArrowBack />
        </IconButton>
      </BackButtonStyledWrapper>
      <FullTailViewSelectorContainer isFullSpaceVehicleView />
      {!isNil(tailDetailsPanelTerminal) && tailDetailsPanelTerminal.restrictionEnabled ? (
        <div className="tail__details__panel____header__restricted__icon__container">
          <Block
            data-test={`tail-details-panel__block-icon__${tailDetailsPanelTerminal.datapathUuid}`}
            className="tail__details__panel____header__restricted__icon"
          />
        </div>
      ) : (
        <IconButton
          sx={{
            marginLeft: '15px',
            '&.Mui-disabled': {
              color: 'white',
            },
          }}
          onClick={() => {
            panToTailOnMap(tailDetailsPanelTerminal, terminals, selectedDatapathUuidFleetView, setMapZoomLatLngFleetView);
          }}
          disabled={isRequestingTailDetailsPanelTerminal}
        >
          <MyLocation
            sx={{
              height: '18px',
              width: '18px',
            }}
          />
        </IconButton>
      )}
    </TailDetailsPanelHeaderDiv>
  );
};

export default SpaceVehicleDetailsPanelFullSpaceVehicleHeader;
